export default "__VITE_ASSET__Dlwgk3VX__"